module.exports = __webpack_public_path__ + "img/oknar-pin.02ec386d.png";